import { useState, useEffect, useCallback } from 'react';
import { useQueryClient } from '@tanstack/react-query';

import { useUserDetails } from '@services/query.service';
import { refreshTokens, signOut, testToken } from '@services/auth.service';

import AuthProviderContext from './auth-provider.context';
import { registerAxiosInterceptor } from './auth-provider.utils';

function AuthProvider({ children }) {
  const [checkedAuthentication, setCheckedAuthentication] = useState(false);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [registeredAxiosInterceptor, setRegisteredAxiosInterceptor] = useState(false);

  const { data: userDetails } = useUserDetails();

  const queryClient = useQueryClient();

  const logOut = useCallback(async () => {
    queryClient.removeQueries({ queryKey: ['user'] });
    await signOut();
    setIsLoggedIn(false);
  }, [queryClient]);

  const logIn = useCallback(() => {
    setIsLoggedIn(true);
  }, []);

  function onAuthCompletion() {
    setCheckedAuthentication(true);
  }

  useEffect(() => {
    if (!registeredAxiosInterceptor) {
      setRegisteredAxiosInterceptor(true);
      registerAxiosInterceptor(logOut);
    }
  }, [logOut, registeredAxiosInterceptor]);

  useEffect(() => {
    if (!checkedAuthentication) {
      testToken()
        .then(() => setIsLoggedIn(true))
        .catch(() => {})
        .catch(() => refreshTokens().then(() => setIsLoggedIn(true)))
        .finally(onAuthCompletion);
    }
  }, [checkedAuthentication]);

  return (
    <AuthProviderContext
      value={{
        isLoggedIn,
        logIn,
        logOut,
        userDetails,
        checkedAuthentication,
      }}
    >
      {children}
    </AuthProviderContext>
  );
}

export default AuthProvider;
